import { Component, Input } from '@angular/core';
import { IconName } from '@fortawesome/free-regular-svg-icons';

@Component({
  selector: 'sigecom-filters-indicator',
  template: `
    <span
      *ngIf="hasFilters"
      class="bg-sigecom-light-danger text-sigecom-danger font-bold text-sm px-2 py-0.5 rounded-full items-center inline-flex ">
      <fa-icon
        [icon]="icon"
        class="text-base mr-1 "
      ></fa-icon>
      Existem filtros sendo aplicados na busca
    </span>
  `,
})
export class FiltersIndicatorComponent {
  @Input() hasFilters = false;
  @Input() icon: IconName = 'circle-info';

}
